import axios from '@/axios'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  countPayment(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/payment/count/${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  createPayment(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('payping/payment', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  createMultiPayment(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('payping/payment/multi', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  crateBlockedPayment(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('payping/payment/blocked', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  verifyPayment(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('payping/payment/verify', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchVerifyPayment(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/payment/verify/?refid=${payload.refid}&clientrefid=${payload.clientrefid}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchPayments(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/payment/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchPaymentIpg(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/payment/ipg/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchUnblockPayment(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/payment/unblock/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchPayment(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/payment/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editPayment(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`payping/payment/${payload.id}`, payload.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removePayment(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`payping/payment/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  /*
   *  Oauth
   */
  countOauth(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/oauth/count/${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  createOauth(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('payping/oauth', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  connectOauth(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('payping/oauth/connect', payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  disconnectOauth() {
    return new Promise((resolve, reject) => {
      axios
        .post('payping/oauth/disconnect')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchOauths(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/oauth/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchOauth(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/oauth/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchOauthToken(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`payping/oauth/token/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editOauth(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`payping/oauth/${payload.id}`, payload.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeOauth(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`payping/oauth/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
